import ClientSupportManagement from "@features/client-support/ClientSupportManagement";
import { AdminOrManagerRoute } from "@shared/guards/RoleBasedGuards";

export const clientSupportRoutes = {
  path: "client-support",
  children: [
    {
      path: "management",
      element: (
        <AdminOrManagerRoute>
          <ClientSupportManagement />
        </AdminOrManagerRoute>
      ),
    },
  ],
};
